import React from 'react';

function Lock(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12 13.25C10.619 13.25 9.5 14.369 9.5 15.75C9.5 17.131 10.619 18.25 12 18.25C13.381 18.25 14.5 17.131 14.5 15.75C14.5 14.369 13.381 13.25 12 13.25ZM12 14.5C12.6907 14.5 13.25 15.0593 13.25 15.75C13.25 16.4407 12.6907 17 12 17C11.3093 17 10.75 16.4407 10.75 15.75C10.75 15.0593 11.3093 14.5 12 14.5Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M12 2C14.6884 2 16.8818 4.1227 16.9954 6.78314L17 7V9.5H17.625C18.6602 9.5 19.5 10.3398 19.5 11.375V20.125C19.5 21.1602 18.6602 22 17.625 22H6.375C5.33982 22 4.5 21.1602 4.5 20.125V11.375C4.5 10.3398 5.33982 9.5 6.375 9.5H7V7C7 4.23899 9.23899 2 12 2ZM15.75 7V9.5H8.25V7L8.2552 6.80088C8.35875 4.82275 9.99614 3.25 12 3.25C14.0707 3.25 15.75 4.92934 15.75 7ZM5.75 11.375C5.75 11.0302 6.03018 10.75 6.375 10.75H17.625C17.9698 10.75 18.25 11.0302 18.25 11.375V20.125C18.25 20.4698 17.9698 20.75 17.625 20.75H6.375C6.03018 20.75 5.75 20.4698 5.75 20.125V11.375Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Lock;
